import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RuleInterface } from '@vendasta/automata';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NoRules } from '../../common';

@Component({
  selector: 'automata-init-partner-subscription-update-panel',
  imports: [CommonModule, TranslateModule],
  templateUrl: './init-partner-subscription-update-panel.component.html',
  styleUrl: './init-partner-subscription-update-panel.component.scss',
})
export class InitPartnerSubscriptionUpdatePanelComponent extends CommonTriggerPanelComponent implements OnInit {
  constructor(
    protected readonly snackbarService: SnackbarService,
    protected readonly translateService: TranslateService,
  ) {
    super();
  }
  // Set up your galaxy form here. The account group creation panel has no options
  // and thus has no special UI to implement here.
  ngOnInit(): void {
    // !!! IMPORTANT !!!
    // If your component has asynchronous pieces, this call should be made when the components are loaded.
    // Otherwise, you can simply call it here.
    this.savingEnabled$.next(true);
  }
  // Return true when your form is valid.
  isFormValid(): boolean {
    return true;
  }
  // This section defines the rules that allow the trigger to fire.
  // These are "templates" -- i.e. any UI-specific values can be set in fillRuleValues().
  // The rule here states "the created and last updated time must be the same"
  // i.e. this is a new account group rather than an updated one.
  // You can access the event parameters using path syntax (e.g. {.created})
  // Some rules require a value taken from the UI rather than.
  // See the added-to-list trigger for an example.
  // Some rules require no rules.
  // See the account-group-user-claimed trigger for an example.
  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }
  // If a rule requires a value from the UI, then the rule must be updated here.
  // See added-to-list for an example.
  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }
  // If the trigger contains any Controls that need to have their input/state validated
  // They should be passed into the return value below to be checked prior to saving successfully
  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }
}
